import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { access, hasAccess, resources } from 'utils/permissions';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { Company } from 'components/common/Elements/Elements';

const Account = ({ data, searchText }) => {
  const { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();
  const hasSensitiveDataReadAccess = hasAccess([
    resources.TENANT_SENSITIVE_DATA,
    access.READ
  ]);
  const {
    customerId,
    company,
    status,
    companySize,
    country,
    website,
    customerType
  } = data;

  return hasSensitiveDataReadAccess ? (
    <NavLink to={generateRegionalPath(`${url}/${customerId}/satisfaction/qbr`)}>
      <Company
        nameCompany={company ? company : customerId}
        status={status}
        description={companySize}
        recordType={customerType}
        country={country}
        domain={website}
        customerId={customerId}
        searchText={searchText}
      />
    </NavLink>
  ) : (
    <Company
      nameCompany={company ? company : customerId}
      status={status}
      description={companySize}
      recordType={customerType}
      country={country}
      domain={website}
      customerId={customerId}
      searchText={searchText}
    />
  );
};

Account.propTypes = {
  data: PropTypes.shape({
    customerId: PropTypes.string,
    company: PropTypes.string,
    country: PropTypes.string,
    status: PropTypes.string,
    companySize: PropTypes.string,
    website: PropTypes.string,
    customerType: PropTypes.string
  }),
  searchText: PropTypes.string
};

export default Account;
